module.exports = __webpack_public_path__ + "static/icons/icon-mountain-c4510c693b51d7e7e3e2a98e425efd52.svg";